const isLocal = typeof window !== 'undefined' && window.location.hostname === "localhost";
export const API_BASE_URL = process.env.REACT_APP_API_URL || (isLocal ? "http://localhost:5000" : "https://fleet-os.dgcars.cloud");
export default API_BASE_URL;
